/*
 * Copyright (c) Nexign, JSC, 2023-2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.27.0
 */

import { MegaPowerSwitchCard, Typography } from '@nexign/scc-ui-kit';
import { useDispatch, useSelector } from 'react-redux';

import { productOfferingsSetMegaPowerAction } from '../wizardProductOfferingsActions';
import { makeSelectProductOfferingsMegaPowers } from '../wizardProductOfferingsSelectors';
import { DangerouslySettedTextStyled, StepSelectMegaPowersStyled } from './styled/StepSelectMegaPowersStyled';

export const StepSelectMegaPowers = () => {
    const megaPowers = useSelector(makeSelectProductOfferingsMegaPowers());
    const dispatch = useDispatch();

    const onSwitchChange = (megaPowerId: number) => {
        dispatch(productOfferingsSetMegaPowerAction({ id: megaPowerId }));
    };

    return (
        <StepSelectMegaPowersStyled>
            {megaPowers.map((megaPower) => (
                <MegaPowerSwitchCard
                    free={!megaPower.recurringCharge}
                    frequency={megaPower?.recurringCharge?.periodUnitName}
                    key={megaPower.id}
                    name={megaPower.name}
                    oneTimeCharge={megaPower.oneTimeCharge}
                    price={megaPower.recurringCharge?.price}
                    switchProps={{
                        onChange: () => onSwitchChange(megaPower.id),
                        disabled: megaPower.readOnly,
                        checked: megaPower.connected,
                    }}
                    tooltipBody={
                        megaPower.description && (
                            <DangerouslySettedTextStyled>
                                <Typography isDangerousInnerHTML>{megaPower.description}</Typography>
                            </DangerouslySettedTextStyled>
                        )
                    }
                    tooltipProps={{ disablePortal: false }}
                    variant="vertical"
                />
            ))}
        </StepSelectMegaPowersStyled>
    );
};
